var _defs, _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.1 327.4",
    xmlSpace: "preserve",
    sodipodiDocname: "logo.svg",
    width: 228.10001,
    height: 327.39999,
    inkscapeVersion: "1.3.2 (091e20e, 2023-11-25, custom)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t.st0{display:none;fill:#FFFFFF;}\n\t.st1{fill:#D80000;}\n\t.st2{fill:#F98800;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_",
    transform: "translate(-306.9,-134.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "m 312.5,391.8 h 5.6 v 20.1 h 22.1 v -20.1 h 11.2 v 53.9 h -11.2 v -23.9 h -22.1 v 23.9 h -11.2 v -48.2 c 0,-3 2.5,-5.7 5.6,-5.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "m 375.2,446.7 c -12.7,-0.4 -19,-7.8 -19,-22.1 0,-14.3 6.4,-21.4 19.2,-21.5 13.3,0 19.6,8.2 18.8,24.6 h -27.1 c 0.4,6.4 3.2,9.7 8.3,9.7 2.5,0 4.8,-1 6.8,-3 1,-1 2.1,-1.5 3.6,-1.5 h 7.8 c -2.3,8.9 -8.1,13.8 -18.4,13.8 z m -8,-26.5 H 383 c -0.6,-5.6 -3.3,-8.4 -7.8,-8.4 -4.5,0 -7.2,2.8 -8,8.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    d: "m 409.7,397 v 48.8 h -10.6 v -53.9 h 5.5 c 2.8,-0.1 5.1,2.3 5.1,5.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    d: "m 415.9,407.2 v -3.4 h 34.3 v 9 l -22.3,23.9 h 22.9 v 9.1 h -36.3 v -8.3 L 437,412.7 h -15.8 c -3,-0.1 -5.3,-2.4 -5.3,-5.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    d: "m 466,409.6 c 2.7,-4.4 6.7,-6.5 11.9,-6.5 11.2,0.4 16.7,7.7 16.7,22 0,14 -6.5,21 -19.5,21.3 -13.1,0.1 -19.7,-6.2 -19.7,-18.8 v -35.8 h 5.3 c 3.5,0 5.2,1.8 5.2,5.3 v 12.5 z m 0,15 c -0.1,8.5 2.8,12.8 8.8,12.8 6,0 9,-4.3 9,-12.8 -0.2,-8.1 -3.2,-12.1 -8.9,-12.1 -5.7,0 -8.6,4 -8.9,12.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    d: "m 503.1,453.2 c 5.8,0 7.9,-2.9 6.2,-8.4 l -14.3,-41 h 12 l 8.3,29.1 7.3,-25.4 c 0.6,-2.5 2.3,-3.7 5,-3.7 h 7.4 l -16.6,49.1 c -2.5,6.9 -5.1,9.3 -13.8,9.3 -2.7,0 -4.1,-0.1 -4.4,-0.3 v -8.6 h 2.9 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "m 502.7,291.9 c 0.9,-39.7 -15.8,-78.9 -55.3,-109 -20.2,-15.4 -40.3,-32.9 -34.5,-48.1 -20.5,14.1 -17.7,37 -0.7,54.8 39.3,40.8 -49,56.8 -27.1,2.5 -21.9,9.2 -21,31.5 -15.5,47.9 12,36 -32,35.8 -24.8,7.6 -2.6,4 -4.8,8.2 -6.7,12.6 0,0 0,0 0,0 -0.1,0.2 -0.2,0.4 -0.3,0.6 -0.1,0.2 -0.2,0.5 -0.3,0.7 -0.2,0.6 -0.4,1.1 -0.7,1.7 0,0.1 0,0.1 -0.1,0.2 -3.7,9.5 -5.7,19.9 -5.7,30.7 0,0 0,0 0,0 0,1.4 0,2.8 0.1,4.1 0,0.1 0,0.3 0,0.4 0.1,1.1 0.1,2.2 0.2,3.3 3.9,43.7 40.7,78 85.4,78 47.4,0 85.8,-38.4 85.8,-85.8 0.3,-0.7 0.2,-1.4 0.2,-2.2 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "m 356,287.6 c -0.1,2.2 0.4,3.8 0.4,3.8 -2.4,-2.5 -2.2,-8.4 -2.2,-8.4 v 0 c 0,-2.7 0.4,-5.8 0.3,-6.6 -0.3,-1.4 -4.9,6.3 -6.9,10.6 -1.8,4 0.6,8.9 9.2,12.1 1.1,-3.7 3.1,-7.1 5.7,-9.9 -1.9,-0.3 -4.8,-0.9 -6.5,-1.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st2",
    d: "m 486.4,287 c -2,-4.3 -6.6,-12 -6.9,-10.6 -0.2,0.8 0.3,3.9 0.3,6.6 v 0 c 0,0 0.2,5.9 -2.2,8.4 0,0 0.5,-1.6 0.4,-3.8 -1.7,0.7 -4.6,1.3 -6.4,1.7 2.6,2.8 4.6,6.1 5.7,9.9 8.5,-3.3 10.9,-8.2 9.1,-12.2 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st3",
    d: "m 451.5,282.9 c -0.5,0 -1,0 -1.5,0.1 l -1.7,0.1 c -4.8,-12.6 -17,-21.6 -31.3,-21.6 -14.3,0 -26.5,9 -31.3,21.6 L 384,283 c -0.5,0 -1,-0.1 -1.5,-0.1 -13.6,0 -24.6,11.1 -24.6,24.6 0,13.6 11.1,24.6 24.6,24.6 0.4,0 0.8,0 1.1,-0.1 v 15 c 10.4,3.7 21.7,5.7 33.4,5.7 11.7,0 22.9,-2 33.4,-5.7 v -14.8 c 0.4,0 0.8,0.1 1.1,0.1 13.6,0 24.6,-11.1 24.6,-24.6 0,-13.8 -11,-24.8 -24.6,-24.8 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "m 450.4,348.9 c -10.5,3.7 -21.7,5.8 -33.4,5.8 -11.7,0 -23,-2 -33.4,-5.7 -1.2,-0.4 -2.4,0.5 -2.4,1.7 v 13.7 c 0,1.2 0.7,2.4 1.8,2.9 10.4,4.6 21.9,7.2 34,7.2 12.1,0 23.7,-2.6 34.1,-7.3 1.1,-0.5 1.8,-1.6 1.8,-2.9 v -13.7 c -0.1,-1.2 -1.3,-2.1 -2.5,-1.7 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st2",
    d: "m 451.5,284.8 c -0.5,0 -1,0 -1.4,0 0,0 -1.7,0 -3.1,0.4 -4.1,-12.7 -15.9,-21.9 -30,-21.9 v 0 0 c -14,0 -25.9,9.2 -30,21.9 -1.5,-0.3 -3.1,-0.4 -3.1,-0.4 -0.5,0 -0.9,0 -1.4,0 -13.4,0 -24.1,11.6 -22.6,25.3 1.1,10.3 9.4,18.7 19.7,20 5.3,0.7 10.3,-0.5 14.5,-3 -10.7,3.8 -29.6,-1.2 -29.5,-17.3 0.2,-22.5 20.9,-19.5 20.9,-19.5 -0.5,6.5 0.9,10.8 0.9,10.8 4.1,-28.1 23.3,-30 29,-29.9 1.1,0 2.1,0 3.2,0 5.7,-0.1 24.9,1.8 29,29.9 0,0 1.4,-4.3 0.9,-10.8 0,0 20.7,-3.1 20.9,19.5 0.2,16.1 -18.7,21.1 -29.5,17.3 4.2,2.5 9.2,3.7 14.5,3 10.3,-1.3 18.6,-9.6 19.7,-20 1.5,-13.7 -9.2,-25.3 -22.6,-25.3 z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st2",
    d: "m 502.7,290.3 c 0.4,-39.1 -16.3,-77.7 -55.3,-107.4 -20.2,-15.4 -40.3,-32.9 -34.5,-48.1 -0.6,0.4 -1.1,0.8 -1.6,1.2 -0.2,0.1 -0.3,0.3 -0.5,0.4 -0.4,0.3 -0.7,0.6 -1.1,0.9 -0.2,0.1 -0.4,0.3 -0.5,0.4 -0.4,0.4 -0.8,0.7 -1.2,1.1 -0.3,0.2 -0.5,0.5 -0.7,0.7 -0.2,0.2 -0.3,0.3 -0.5,0.5 -0.3,0.3 -0.5,0.6 -0.8,0.9 0,0 0,0.1 -0.1,0.1 -12.5,14.1 -8.4,33.3 6.4,48.6 39.3,40.8 -49,56.8 -27.1,2.5 -21.9,9.2 -21,31.5 -15.5,47.9 12,36 -32,35.8 -24.8,7.6 -7.6,14.7 2.3,29.9 20.2,25.9 17.8,-4 21.1,-21.5 16.3,-31.5 -5.2,-10.8 -4.3,-18.2 -4.3,-18.2 4.5,12.1 17.3,16 31.2,14.4 13.9,-1.6 26.3,-14.9 24.7,-28.8 -1.5,-12.6 -7.9,-18.6 -19.4,-32.3 -3.8,-5.3 -6.6,-12.2 -5.1,-20.3 0.1,0.1 4.8,12.4 37.5,34.7 33.4,22.7 49,61.3 49.1,61.5 3.3,9.2 7,23.8 7.6,37.3 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.de817c99f33186600f6d29c41315b3b3.svg";
export { ForwardRef as ReactComponent };